import { render } from "./SelectorParentInterestsCategories.vue?vue&type=template&id=38c1f766&scoped=true"
import script from "./SelectorParentInterestsCategories.vue?vue&type=script&lang=js"
export * from "./SelectorParentInterestsCategories.vue?vue&type=script&lang=js"

import "./SelectorParentInterestsCategories.vue?vue&type=style&index=0&id=38c1f766&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c1f766"]])

export default __exports__